import React from 'react';
import IconButton from 'react-toolbox/lib/button';
import styles from 'components/DrawerLayout.css';

const DrawerLayout = ({ children, header, onClose }) =>
  <div className={styles.container}>
    <div className={styles.headerContainer}>
      {header}
      {onClose && <IconButton theme={styles} icon="close" onClick={onClose} />}
    </div>
    <div className={styles.bodyContainer}>
      {children}
    </div>
  </div>;

export default DrawerLayout;
